var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 121.641,
    height: 98.906,
    viewBox: "0 0 121.641 98.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17c8e7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#17c8e7",
    stopOpacity: 0.855
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00d9ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_99",
    x: 80.189,
    y: 2.025,
    width: 35.243,
    height: 43.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_100",
    x: 87.337,
    y: 0,
    width: 21.135,
    height: 48.396,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_101",
    x: 73.245,
    y: 12.971,
    width: 48.396,
    height: 21.135,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_102",
    x: 76.312,
    y: 7.365,
    width: 42.637,
    height: 34.287,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1bc9e7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_99-2",
    x: 6.944,
    y: 52.535,
    width: 35.243,
    height: 43.496,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_100-2",
    x: 14.092,
    y: 50.511,
    width: 21.135,
    height: 48.396,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_101-2",
    x: 0,
    y: 63.482,
    width: 48.396,
    height: 21.135,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_102-2",
    x: 3.067,
    y: 57.876,
    width: 42.637,
    height: 34.287,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#00d9ff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "matrix(-0.819, 0.574, -0.574, -0.819, 122.543, 28.706)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 91,
    height: 3,
    transform: "translate(16.471 16.685)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, 83.92, 93.8)",
    filter: "url(#Rectangle_99)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99-3",
    "data-name": "Rectangle 99",
    width: 36.455,
    height: 2.848,
    transform: "matrix(0.57, 0.82, -0.82, 0.57, 88.52, 8.02)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, 83.92, 93.8)",
    filter: "url(#Rectangle_100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100-3",
    "data-name": "Rectangle 100",
    width: 36.455,
    height: 2.848,
    transform: "translate(102.47 6.49) rotate(100)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, 83.92, 93.8)",
    filter: "url(#Rectangle_101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101-3",
    "data-name": "Rectangle 101",
    width: 36.455,
    height: 2.848,
    transform: "translate(79.74 18.97) rotate(10)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, 83.92, 93.8)",
    filter: "url(#Rectangle_102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102-3",
    "data-name": "Rectangle 102",
    width: 36,
    height: 2,
    transform: "matrix(-0.82, 0.57, -0.57, -0.82, 112.95, 15)",
    fill: "url(#radial-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M14.142,0l.383,5.474L20,5.858,16.4,10,20,14.142l-5.474.383L14.142,20,10,16.4,5.858,20l-.383-5.474L0,14.142,3.6,10,0,5.858l5.474-.383L5.858,0,10,3.6Z",
    transform: "translate(27 27.728) rotate(180)",
    fill: "url(#radial-gradient-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245",
    transform: "translate(88.97 0.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243-2",
    "data-name": "Group 243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, -5.05, 93.17)",
    filter: "url(#Rectangle_99-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99-4",
    "data-name": "Rectangle 99",
    width: 36.455,
    height: 2.848,
    transform: "matrix(0.57, 0.82, -0.82, 0.57, 15.28, 58.54)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, -5.05, 93.17)",
    filter: "url(#Rectangle_100-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100-4",
    "data-name": "Rectangle 100",
    width: 36.455,
    height: 2.848,
    transform: "translate(29.23 57.01) rotate(100)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, -5.05, 93.17)",
    filter: "url(#Rectangle_101-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101-4",
    "data-name": "Rectangle 101",
    width: 36.455,
    height: 2.848,
    transform: "translate(6.49 69.48) rotate(10)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.82, -0.57, 0.57, -0.82, -5.05, 93.17)",
    filter: "url(#Rectangle_102-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102-4",
    "data-name": "Rectangle 102",
    width: 36,
    height: 2,
    transform: "matrix(-0.82, 0.57, -0.57, -0.82, 39.7, 65.51)",
    fill: "url(#radial-gradient-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3-2",
    "data-name": "Polygon 3",
    d: "M14.142,0l.383,5.474L20,5.858,16.4,10,20,14.142l-5.474.383L14.142,20,10,16.4,5.858,20l-.383-5.474L0,14.142,3.6,10,0,5.858l5.474-.383L5.858,0,10,3.6Z",
    transform: "translate(27 27.728) rotate(180)",
    fill: "url(#radial-gradient-6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVx);
export default __webpack_public_path__ + "static/media/vx.6b1203bea8817a00d97ea7b39019ef44.svg";
export { ForwardRef as ReactComponent };